import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white border-t border-[#0B702A]/20">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_pentest-pro-8/artifacts/ya7dklvx_Logo%20branco.png"
              alt="Software Secure"
              className="h-10 w-auto"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#014421] flex items-center justify-center hover:bg-[#0B702A] transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#014421] flex items-center justify-center hover:bg-[#0B702A] transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#014421] flex items-center justify-center hover:bg-[#0B702A] transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#0B702A]">{t.footer.services}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/pentest" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Pentest
                </Link>
              </li>
              <li>
                <Link to="/secure-development" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Desenvolvimento Seguro
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Auditoria de Segurança
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Consultoria
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#0B702A]">{t.footer.company}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Cases de Sucesso
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#0B702A] transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#0B702A]">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Mail className="w-5 h-5 text-[#0B702A] flex-shrink-0 mt-0.5" />
                <span>software.secure.adm@gmail.com</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Phone className="w-5 h-5 text-[#0B702A] flex-shrink-0 mt-0.5" />
                <span>(11) 96840-2230</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-5 h-5 text-[#0B702A] flex-shrink-0 mt-0.5" />
                <span>São Paulo, SP - Brasil</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#0B702A]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Software Secure. {t.footer.rights}.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Shield className="w-4 h-4 text-[#0B702A]" />
              <span>Segurança é nossa prioridade</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;